import { Dropdown } from '@carbon/react';
import { SCAN_DEPTH_OPTIONS } from './utils';
import type { ScanDepth } from './utils';
import styles from './scan-depth-dropdown.module.scss';

interface ScanDepthDropdownProps {
  id: string;
  value: ScanDepth;
  onChange: (scanDepth: ScanDepth) => void;
  disabled?: boolean;
}

/**
 * The scan-depth choice (5k … All) shared by the Sidekiq queue admin pages,
 * sent as `sample_limit`. Its accessible name is "Scan depth"; the visible
 * label is hidden, since the selected value says what it is.
 *
 * @param {ScanDepthDropdownProps} props - The id, the chosen depth and its change handler.
 * @return The dropdown.
 */
export function ScanDepthDropdown({
  id,
  value,
  onChange,
  disabled = false,
}: ScanDepthDropdownProps) {
  return (
    <Dropdown
      id={id}
      titleText="Scan depth"
      hideLabel
      className={styles.scanDepthDropdown}
      label="Scan depth"
      size="sm"
      items={[...SCAN_DEPTH_OPTIONS]}
      itemToString={(item) => (item ? item.label : '')}
      selectedItem={
        SCAN_DEPTH_OPTIONS.find((option) => option.id === value) ?? null
      }
      onChange={({ selectedItem }) => {
        if (selectedItem) onChange(selectedItem.id);
      }}
      disabled={disabled}
    />
  );
}
